export default __webpack_public_path__ + "static/media/b4.56d666e7.jpg";